module.exports = __webpack_public_path__ + "media/images/abacus-carbono-83dde4e5.png";